import byteSize from 'byte-size'
import { Owner } from '../../core/models/owner'
import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'
import { FileBranch } from './file-branch'
import { FileFormats } from './file-formats'

export class SystemFile extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new SystemFile(), {
      branches: FileBranch.serialisationConfig,
      formats: FileFormats.serialisationConfig,
      owner: Owner.serialisationConfig,
    })

  @alias('id')
  id!: number
  @alias('name')
  name!: string
  @alias('type')
  type!: string
  @alias('mime_type')
  mimeType!: string
  @alias('size')
  size!: number
  @alias('url')
  url!: string
  @alias('branches')
  branches!: FileBranch[]
  @alias('formats')
  formats!: FileFormats | null
  @alias('owner')
  owner!: Owner | null
  @alias('created_at')
  created!: Date
  @alias('updated_at')
  updated!: Date

  get typeTitle(): string {
    return [
      this.type.substring(0, 1).toLocaleUpperCase(),
      this.type.substring(1),
    ].join('')
  }

  get formattedSize(): string {
    if (this.type === 'folder') {
      return ''
    }
    if (this.size) {
      return byteSize(this.size).toString()
    }
    return 'Unknown'
  }

  get extension(): string | null {
    if (this.type !== 'folder') {
      const index = this.name.lastIndexOf('.')
      if (index >= 0) {
        return this.name.substring(index)
      }
    }
    return null
  }

  get path(): string {
    return this.branches.map(({ name }) => name).join(' / ')
  }

  constructor() {
    super((SystemFile as unknown as AliasedConstructor)._alias)
  }

  static create<Data>(attrs: Data) {
    return new SystemFile().update(attrs, SystemFile.serialisationConfig)
  }
}
